import React from 'react';
import { Logo } from '../components/Logo';
import { Loader2Icon } from 'lucide-react';
export function LoadingScreen() {
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-navy" data-id="element-668">
      <Logo size="lg" className="mb-8" data-id="element-669" />

      <div className="flex flex-col items-center" data-id="element-670">
        <Loader2Icon className="w-8 h-8 text-amber animate-spin mb-6" data-id="element-671" />
        <h2 className="text-xl font-serif text-white mb-2" data-id="element-672">
          Loading documents...
        </h2>
        <p className="text-gray-400 text-sm" data-id="element-673">
          This may take a few seconds for large cases.
        </p>
      </div>
    </div>;
}